import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { matchPath, useLocation } from "react-router-dom";
import { imageUpload, videoUpload, handleContinueEmpty } from '../helpers/index';
import AppContext from "../utils/app-context";
import { AuthContext } from "../utils/auth-provider";
import firebase from '../utils/firebase';
import { useDropzone } from 'react-dropzone'
import { nanoid } from "nanoid";
import toast from 'react-hot-toast';
import assets from "../utils/assets"
import { useNavigate } from "react-router-dom";
import { addEmptyShot } from "../helpers/index"
import { current } from 'immer';
import LoginDialog from './dialogs/login';

const DropUpload = (props) => {
    const { type = "default", children, dropFunc, mediaRestrict, mode = "take", view = "hidden", shotId = null, part = null, status = "", callback, partId, text = "Drop media or click to upload" } = props
    const { state, dispatch } = useContext(AppContext);
    const loc = useLocation();
    const { currentUser } = useContext(AuthContext);
    const [vidFile, setVidFile] = React.useState(null);
    const [showAuth, setShowAuth] = React.useState(false);
    let path = null
    if (mode === 'shot') {
        path = matchPath({
            path: '/p/:id',
            exact: false,
            string: false
        }, loc.pathname)
    } else if (mode === 'take') {
        path = matchPath({
            path: '/p/:id/:shotID',
            exact: false,
            string: false
        }, loc.pathname)
    } else {
        path = loc.pathname;
    }
    const navigate = useNavigate();
    const currentShotId = (shotId) ? shotId : (path?.params?.shotID) ? path.params.shotID : null;
    const storyImport = (props.type.indexOf("story-import") != -1 ? true : false)
    const newStory = (storyImport && props.type.indexOf("-new") != -1) ? true : false;
    const portalId = storyImport && newStory ? nanoid(12) : props.portalId;
    const isVertical = state.stories.activeStory?.is_vertical;
    const addItemStyles = {
        height: "100%",
        minHeight: mode === "shot" ? (isVertical ? "300px" : "220px") : (isVertical ? "220px" : "150px"),
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        alignSelf: "center",
        flexDirection: "column",
        justifyContent: "space-around",
        width: "100%",
        margin: "0 auto",
        borderRadius: "6px",
        backgroundColor: "var(--bg-surface)",
    };
    function capWord(word) {
        return word[0].toUpperCase() + word.substring(1);
    }
    const uploadVideo = async () => {
        const success = await videoUpload({ file: vidFile, shot_id: currentShotId, state: state, dispatch: dispatch, storyImport: storyImport, portalId: portalId || null, callback: callback, currentUser: currentUser, firebase: firebase, is_vertical: state.stories.activeStory?.is_vertical || false })
        setVidFile(null);
        return success;
    }

    useEffect(async () => {
        if (storyImport && vidFile) {
            const success = await uploadVideo();
            if (success && newStory) {
                navigate("/p/" + portalId);
            }
        }
    }, [vidFile]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        noDragEventsBubbling: true,
        onDrop: (acceptedFiles) => {
            if (!currentUser) {
                toast.error("You must log in to upload media");
                setShowAuth(true);
                return;
            }
            if (mode === 'shot') {
                acceptedFiles.forEach((file) => {
                    let newShotId = nanoid()
                    if (file.type.indexOf("image") != -1)
                        imageUpload({
                            file: file,
                            shot_id: newShotId,
                            state: state,
                            is_ref: (mode == "reference") ? true : false,
                            dispatch: dispatch,
                            currentUser: currentUser,
                            firebase: firebase,
                            path: path,
                            callback: callback
                        }).then(() => {
                            addEmptyShot({ shotId: newShotId, partId: part?.id, dispatch: dispatch, state: state, uploading: true })
                        }).catch(() => {
                            toast.error('error adding shot')
                        })
                    else if (file.type.indexOf("video") != -1) {
                        const success = videoUpload({
                            file: file,
                            shot_id: newShotId,
                            state: state,
                            dispatch: dispatch,
                            is_ref: (mode == "reference") ? true : false,
                            currentUser: currentUser,
                            firebase: firebase,
                            callback: callback
                        }).then((success) => {
                            if (!success) return;
                            addEmptyShot({ shotId: newShotId, partId: part?.id, dispatch: dispatch, state: state })
                        }).catch(() => {
                            toast.error('error adding shot')
                        })
                    }
                    else toast.error("File type not compatible.");
                })
            } else {
                if (dropFunc) dropFunc();
                acceptedFiles.forEach((file) => {
                    if (file.type.indexOf('image') != -1 && mediaRestrict != "video") {
                        if (mode == "reference") {
                            imageUpload({ file: file, state: state, dispatch: dispatch, currentUser: currentUser, firebase: firebase, path: path, is_ref: true, shot_id: null, callback: callback })
                        } else {
                            imageUpload({ file: file, state: state, dispatch: dispatch, shot_id: currentShotId, currentUser: currentUser, firebase: firebase, path: path, is_ref: false, callback: callback })
                        }
                    }
                    else if (file.type.indexOf('video') != -1 && mediaRestrict != "image") {
                        if (storyImport) {
                            setVidFile(file);
                            /* commented out for import nav
                            if(newStory) {
                                const portalId = (!props.portalId) ? nanoid(12) : props.portalId; 
                                handleContinueEmpty({dispatch:dispatch, portalId:portalId});
                                navigate("/p/" + portalId);
                            }*/
                            // else uploadVideo();                            
                        } else {
                            videoUpload({ file: file, shot_id: currentShotId, is_ref: (mode == "reference") ? true : false, state: state, storyImport: storyImport, /*portalId: props.portalId, */callback: callback, dispatch: dispatch, currentUser: currentUser, firebase: firebase })
                        }
                    } else alert('File type not compatible.')
                })
            }

        },
        onDragEnter: (e) => {
            e.preventDefault();
            e.stopPropagation();
        },
        onDragLeave: (e) => {
            e.preventDefault();
            e.stopPropagation();
        },
        maxFiles: 10,
        onDropRejected: () => {
            alert("You cannot upload more then 10 files.")
        }
    })

    const storyStyles = {
        width: "calc(100% - 4px)",
        height: "calc(100% - 4px)",
        minHeight: storyImport ? "150px" : "auto",
        border: (type == "wrap") ? "none" : "2px dashed var(--border-strong, rgba(0, 0, 0, 0.15))",
        transition: "all .5s ease-in-out",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "5px",
        "&:hover": {
            background: "var(--bg-hover, rgba(0, 0, 0, 0.15))"
        },
        background: (isDragActive) ? "var(--bg-hover, rgba(0, 0, 0, 0.15))" : "transparent"
    }

    const overlayStyles = {
        display: isDragActive ? 'flex' : 'none',
        position: (type == "wrap") ? 'absolute' : 'fixed',
        top: 0,
        left: 0,
        width: (type == "wrap") ? "100%" : '100vw',
        height: (type == "wrap") ? "100%" : '100vh',
        backgroundColor: (type == "wrap") ? 'var(--bg-hover)' : 'var(--overlay-scrim)',
        outline: (type == "wrap") ? '2px solid var(--border-focus)' : 'none',
        outlineOffset: '-2px',
        borderRadius: (type == "wrap") ? '6px' : 0,
        color: 'var(--text-primary)',
        zIndex: 999999,
        textAlign: 'center',
        fontSize: '20px',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        fontWeight: 600
    }

    const onFileUploadChangeMobile = async (event, source) => {
        let files = await event.target.files;

        if (!currentUser) {
            toast.error("You must log in to upload media");
            navigate('/login');
            return;
        }

        Array.from(files).forEach(file => {
            let newShotId = nanoid()
            if (file.type.indexOf("image") == -1 && file.type.indexOf("video") == -1) {
                alert("Only images and videos can be uploaded.");
                return;
            }
            if (mode === 'shot') {
                if (file.type.indexOf("image") != -1) {
                    imageUpload({
                        file: file,
                        shot_id: newShotId,
                        state: state,
                        dispatch: dispatch,
                        currentUser: currentUser,
                        is_ref: false,
                        firebase: firebase,
                        source: source
                    }).then(() => {
                        addEmptyShot({ shotId: newShotId, partId: part?.id, dispatch: dispatch, state: state })
                    }).catch(() => {
                        toast.error('error adding shot')
                    })
                } else {
                    videoUpload({
                        file: file,
                        shot_id: newShotId,
                        state: state,
                        dispatch: dispatch,
                        is_ref: (mode == "reference") ? true : false,
                        storyImport: storyImport,
                        currentUser: currentUser,
                        firebase: firebase,
                        source: source
                    }).then(() => {
                        addEmptyShot({ shotId: newShotId, partId: part?.id, dispatch: dispatch, state: state })
                    }).catch(() => {
                        toast.error('error adding shot')
                    })
                }
            } else {
                if (file.type.indexOf("image") != -1) {
                    imageUpload({
                        file: file,
                        shot_id: currentShotId,
                        state: state,
                        dispatch: dispatch,
                        is_ref: (mode == "reference") ? true : false,
                        currentUser: currentUser,
                        firebase: firebase,
                        source: source
                    })
                } else {
                    videoUpload({ file: file, shot_id: currentShotId, state: state, storyImport: storyImport, /*portalId: portalId, */callback: callback, currentUser: currentUser, dispatch: dispatch, firebase: firebase, source: source });
                }
            }

        })
    }

    const draggableChildren = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a
        // typescript error too.
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { ...getRootProps({ onClick: e => e.stopPropagation() }) });
        }
        return child;
    });

    let addText = (mode == "shot") ? "Add Media Shot" : (mode == "reference") ? "Add Reference Image" : "Add Take";
    let addEmptyStyles = {
        height: "50%", width: "100%", cursor: "pointer",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        borderTop: '2px solid transparent',
        borderLeft: '2px solid transparent',
        borderRight: '2px solid transparent',
        borderBottom: "1px solid var(--border-subtle, #32353E)",
        padding: "8px",
        '&:hover': {
            border: '2px dashed var(--border-strong, #4B5260)',
        }
    }
    let addMediaStyles = {
        height: "50%",
        width: "100%",
        cursor: "pointer",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid transparent",
        padding: "8px",
        '&:hover': {
            border: '2px dashed var(--border-strong, #4B5260)',
            '.drop': {
                display: 'block'
            }
        },
    }
    let addMobileStyles = {
        height: "50%",
        width: "100%",
        minWidth: "100%",
        cursor: "pointer",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
    }
    if (mode == "take") addMediaStyles.height = "100%"

    const checkAuth = (e) => {
        if (!currentUser) {
            e.preventDefault();
            e.stopPropagation();
            toast.error("You must log in to upload media");
            setShowAuth(true);
            return;
        }
    }

    const mobileAdd =
        <Box sx={addMobileStyles}>
            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
                <label href="#" className="image_wrapper_label image-file-upload" style={{ border: "none", textAlign: "center", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", height: "100%", color: "var(--text-primary, #272727)" }} onClick={checkAuth}>
                    <Box>
                        <input value={null} type="file" accept="image/*" onChange={(e) => onFileUploadChangeMobile(e, "camera")} capture="environment" hidden />
                        <PhotoCameraIcon sx={{ fontSize: "45px", color: "var(--text-primary)" }} />
                    </Box>
                </label>
                <label href="#" className="image_wrapper_label image-file-upload" style={{ border: "none", textAlign: "center", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", height: "100%", color: "var(--text-primary, #272727)" }} onClick={checkAuth}>
                    <Box>
                        <input value={null} type="file" accept="video/*" onChange={(e) => onFileUploadChangeMobile(e, "camera")} capture="environment" hidden />
                        <VideocamIcon sx={{ fontSize: "45px", color: "var(--text-primary)" }} />
                    </Box>
                </label>
                <label href="#" className="image_wrapper_label image-file-upload" style={{ border: "none", textAlign: "center", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", height: "100%", color: "var(--text-primary, #272727)" }} onClick={checkAuth}>
                    <Box>
                        <input value={null} type="file" accept="video/*, image/*" onChange={(e) => onFileUploadChangeMobile(e, "upload")} multiple />
                        <FileUploadIcon sx={{ fontSize: "45px", color: "var(--text-primary)" }} />
                    </Box>
                </label>
            </Box>
            <Typography style={{ textAlign: "center", marginBottom: '10px' }}>{addText}</Typography>
        </Box>

    return (
        <>
            <input style={{
                display: 'block'
            }} {...getInputProps()} />
            {view == "upload" &&
                <Box {...getRootProps()} sx={storyStyles}>
                    {text}
                </Box>
            }
            <LoginDialog open={showAuth} onClose={() => { setShowAuth(false) }} redirect={location.pathname} />
            {!storyImport && <Box {...getRootProps()} style={overlayStyles} ref={props.fileUploadRef}  >
                Drop Media to import as {capWord(mode)}{part ? ` to ${part?.title}` : ''}
            </Box>}
            {!storyImport && type == "add" && mode != "reference" &&
                <Box sx={{ height: "100%", width: "100%" }}>
                    <Box sx={{ ...addItemStyles, border: mode == "shot" ? "var(--border-shot-card)" : "1px solid var(--border-subtle)" }} className="card-cont">
                        {mode == "shot" &&

                            <Box {...getRootProps()} sx={addEmptyStyles} onClick={() => addEmptyShot({ dispatch: dispatch, state: state, partId: part?.id })}>
                                <Box sx={{ padding: "6px", textAlign: "center" }}>
                                    <AddIcon sx={{ fontSize: "32px", color: "var(--text-primary)" }} />
                                    <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "var(--text-primary)" }}>Add Empty Shot</Typography>
                                </Box>
                            </Box>
                        }
                        {!state.app.isMobile && !children &&
                            <Box {...getRootProps()} sx={addMediaStyles}>
                                <Box sx={{ padding: "6px", textAlign: "center" }} onClick={(e) => checkAuth(e)}>
                                    <AddIcon sx={{ fontSize: "32px", color: "var(--text-primary)" }} />
                                    <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "var(--text-primary)" }}>{addText}</Typography>
                                    <Typography className="drop" sx={{ display: "none", fontSize: "11px", color: "var(--text-secondary)" }}>(Or Drop Media)</Typography>
                                </Box>
                            </Box>
                        }
                        {state.app.isMobile && !storyImport && type == "add" &&
                            mobileAdd
                        }
                    </Box>
                </Box>
            }
            {!storyImport && type == "wrap" &&
                <>
                    {draggableChildren}
                </>
            }
        </>
    )
}

export default DropUpload;